"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseRegModal = exports.normaliseDNRDModal = void 0;
var RegExFilter_1 = require("@eres/core/dist/TextFilters/RegExFilter");
function TrimMultiSpaces(input) {
    if (input) {
        return input.replace(/\s+/, " ").trim();
    }
    return input;
}
function normaliseDNRDModal(data) {
    if (data) {
        data.NameEn = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.NameEn + "", true, RegExFilter_1.EnglishChars, RegExFilter_1.SpaceChars));
        data.NameAr = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.NameAr + "", true, RegExFilter_1.ArabicChars, RegExFilter_1.SpaceChars));
        data.BirthPlaceNameAr = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.BirthPlaceNameAr + "", true, RegExFilter_1.ArabicChars, RegExFilter_1.SpaceChars));
        data.BirthPlaceNameEn = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.BirthPlaceNameEn + "", true, RegExFilter_1.ArabicChars, RegExFilter_1.SpaceChars));
    }
    return data;
}
exports.normaliseDNRDModal = normaliseDNRDModal;
function normaliseRegModal(data) {
    if (data) {
        if (data.PersonName) {
            data.PersonName.ArabicName = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.PersonName.ArabicName + "", true, RegExFilter_1.ArabicChars, RegExFilter_1.SpaceChars));
            data.PersonName.EnglishName = TrimMultiSpaces((0, RegExFilter_1.filterCharSet)(data.PersonName.EnglishName + "", true, RegExFilter_1.EnglishChars, RegExFilter_1.SpaceChars));
        }
    }
    return data;
}
exports.normaliseRegModal = normaliseRegModal;
